import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['savePrescriptionLink', 'drugsContainer']

  loadSavedPrescription(event) {
    let saved_prescription_id = $(event.srcElement).data('saved-prescription-id')

    $(this.savePrescriptionLinkTarget).addClass('hidden')
    $.ajax({
      url: this.data.get('url').replace(':id:', saved_prescription_id)
    })
  }

  validateDrugAdded(e) {
    if ($(this.drugsContainerTarget).find('input').length == 0) {
      toastr.success('Adicione ao menos um medicamento')
      e.preventDefault()
    }
  }
}
